import {Datagrid} from 'components/refinedev/Datagrid';
import {createColumnHelper} from '@tanstack/react-table';
import {LiveSearchFilter} from 'components/refinedev/filter-forms/LiveSearchFilter';
import {
  CreateButton,
  DeleteButtonWithConfirmation,
  EditButton,
} from 'components/refinedev/action_buttons';
import {defaultQueryOptions} from 'pages/_utils';
import {HttpError, useTable} from '@refinedev/core';
import StateBoundary from '@/components/basic/StateBoundary';
import {DataTableColumnHeader} from '@/components/data-table/data-table-column-header';
import useRefineTanstackDataTable from '@/hooks/refinedev/useRefineTanstackDataTable';
import {DataTable} from '@/components/data-table/data-table';
import DefaultDataTableToolbar from '@/components/refinedev/data-table/DefaultDataTableToolbar';
import { useBulkDelete } from '@/components/refinedev/data-table/use-bulk-delete';

const thisResource = 'jobs';

const columnHelper = createColumnHelper<any>();

const columns = [
  columnHelper.accessor('id', {
    meta: {label: 'ID'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => info.getValue(),
  }),
  columnHelper.accessor('title', {
    meta: {label: 'Tên công việc'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => info.renderValue(),
  }),
  columnHelper.display({
    id: 'actions',
    meta: {label: 'Hành động'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => (
      <div className="flex flex-row">
        <EditButton id={String(info.row.getValue('id'))} resource={thisResource} />
        <DeleteButtonWithConfirmation
          id={String(info.row.getValue('id'))}
          resource={thisResource}
        />
      </div>
    ),
  }),
];

const JobList = () => {
  const {refineTable, tanstackTable} = useRefineTanstackDataTable(
    {
      resource: thisResource,
      sorters: {initial: [{field: 'id', order: 'asc'}]},
      queryOptions: defaultQueryOptions,
    },
    {columns},
  );
  const bulkDelete = useBulkDelete(thisResource, tanstackTable);

  return (
    <StateBoundary
      isLoading={refineTable.tableQuery.isLoading}
      error={refineTable.tableQuery.error}>
      <div className="p-2">
        <DataTable
          table={tanstackTable}
          toolbar={
            <DefaultDataTableToolbar
              resource={thisResource}
              table={tanstackTable}
              bulkActions={[bulkDelete]}
            />
          }
        />
      </div>
    </StateBoundary>
  );
};

JobList.table_columns = columns;

export default JobList;
